import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown } from "../../../common/component/Index";
import SiteInfo from './../../../../../models/SiteInfo';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import { PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import moment from "moment";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';

const ListCols = ['name', 'key', 'value', 'createdDate', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new SiteInfo());

class SiteInfoList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    key: 'name',
                    sorter: (i, k) => i.name.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => <p>{text}</p>
                },
                key: {
                    key: 'key',
                render: (text, record) => <p>{text}</p>
                },
                value: {
                    key: 'value',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={400}
                        overlayClassName={'max-width-500'} />
                },
                createdDate: {
                    width: 150,
                    key: 'createdDate',
                    sorter: (i, k) => i.createdDate.length - k.length,
                    render: (date, record) => moment(moment.utc(date).toDate().toJSON()).format('DD-MM-YYYY HH:mm'),
                },
                translations: {
                    key: 'languageCode',
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, siteinfos } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="siteinfos-list"
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(siteinfos || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'siteinfo'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                onColumnVisibleChange={this.onColumnVisibleChange}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeSiteInfo = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.siteinfo.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeSiteInfo,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.SITEINFO.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    getTableColumns() {
        return Func.getTitleTable(['name', 'key', 'value', 'createdDate', 'translations'], ['action'], []);
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }


}

export default withTranslation()(SiteInfoList);
